<template>
  <div class="no-role-wrapper">
    <div class="no-role-container">
      <h1>No Role Assigned</h1>
      <p class="message">You currently do not have any role assigned in the system.</p>
      <p class="sub-message">
        Please contact the application owner or your administrator for access.
      </p>
      <el-button type="primary" @click="logoutUser" class="home-button">Go to Login Page</el-button>
    </div>
  </div>
</template>

<script>
  import applicationUsersForbidden from '@/mixins/applicationUsersForbidden';
  export default {
    name: 'ApplicationUsersNoRole',
    mixins: [applicationUsersForbidden],
  };
</script>

<style scoped>
  .no-role-wrapper {
    position: relative;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;

    /* Background Layers */
    background-image:
      linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('../../assets/7714.jpg'),
      linear-gradient(160deg, #1e3c72, #2a5298);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 0;
  }

  /* Main Box */
  .no-role-container {
    background-color: rgba(255, 255, 255, 0.95);
    border-radius: 10px;
    padding: 40px;
    max-width: 600px;
    width: 90%;
    text-align: center;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    z-index: 1;
  }

  .no-role-container h1 {
    color: #d48806;
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 16px;
  }

  .message {
    font-size: 17px;
    color: #333;
    margin-bottom: 10px;
  }

  .sub-message {
    font-size: 15px;
    color: #555;
    margin-bottom: 20px;
  }

  .home-button {
    font-weight: 500;
    font-size: 14px;
    padding: 10px 20px;
    transition: all 0.3s ease;
    background-color: #409eff;
    border-color: #409eff;
    color: #fff;
  }

  .home-button:hover {
    background-color: #66b1ff;
    border-color: #66b1ff;
    color: #fff;
    cursor: pointer;
  }
</style>
